const o={highContrast:{type:"boolean",className:"rt-high-contrast",default:void 0}};export{o as highContrastPropDef};
//# sourceMappingURL=high-contrast.prop.js.map
